"use client";

import React, { useState } from "react";
import InsuranceTopBar from "@/components/demos/insurance/InsuranceTopBar";
import InsuranceHero from "@/components/demos/insurance/InsuranceHero";
import InsuranceProductsSection from "@/components/demos/insurance/InsuranceProductsSection";
import UnderwritingTrustSection from "@/components/demos/insurance/UnderwritingTrustSection";
import QuoteProposalModal from "@/components/demos/insurance/QuoteProposalModal";
import { InsuranceProduct } from "@/lib/demos/insuranceData";

export default function InsuranceLandingPage() {
  const [currency, setCurrency] = useState<"INR" | "USD">("INR");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalInitialData, setModalInitialData] = useState<any | null>(null);

  const handleOpenProposalFromHero = (data?: any) => {
    setModalInitialData(data || null);
    setIsModalOpen(true);
  };

  const handleSelectProduct = (product: InsuranceProduct) => {
    const sum = currency === "USD" ? product.defaultSumAssuredUSD : product.defaultSumAssuredINR;
    const prem = currency === "USD" ? product.indicativeAnnualPremiumUSD : product.indicativeAnnualPremiumINR;

    setModalInitialData({
      productId: product.id,
      productName: product.name,
      sumAssured: sum,
      annualPremium: prem,
      age: 32,
      isTobaccoUser: false,
    });
    setIsModalOpen(true);
  };

  return (
    <main className="min-h-screen flex flex-col bg-slate-950">
      {/* Persistent Navigation Bar */}
      <InsuranceTopBar
        activeTab="portal"
        currency={currency}
        onCurrencyToggle={setCurrency}
      />

      {/* Hero with Interactive Premium Calculator */}
      <InsuranceHero
        currency={currency}
        onOpenProposalModal={handleOpenProposalFromHero}
      />

      {/* Flagship Insurance & Wealth Catalog */}
      <InsuranceProductsSection
        currency={currency}
        onSelectProduct={handleSelectProduct}
      />

      {/* Underwriting Trust & Accreditation */}
      <UnderwritingTrustSection />

      {/* Footer */}
      <footer className="bg-slate-950 border-t border-slate-900 py-10 px-4 text-center text-xs text-slate-500">
        <p className="text-slate-400 font-medium">
          Aegis Prime Wealth &amp; Insurance Partners • IRDAI Registration No. 892/2019
        </p>
        <p className="mt-1">
          Prestige Trade Tower, Palace Road, Bangalore 560001 • Official InsurTech Solution by Johnson Softwares
        </p>
      </footer>

      {/* Proposal & e-KYC Modal */}
      <QuoteProposalModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        currency={currency}
        initialData={modalInitialData}
      />
    </main>
  );
}
